import { render, staticRenderFns } from "./chatMonitoring.vue?vue&type=template&id=34feb0a6&scoped=true"
import script from "./chatMonitoring.vue?vue&type=script&lang=js"
export * from "./chatMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34feb0a6",
  null
  
)

export default component.exports